import { ApiResponse } from 'apisauce';

import { APIResponse, GatewayResponse, GatewayResponseStatus, ProtectedRoute } from '~types/gateway';

import { IGoldGateway } from './goldBase';

import {
    TCreateBuyGoldTransactionAPIParams,
    TCreateGoldConversionAPIParams,
    TCreateInventoryAPIParams,
    TCreateTransactionDraftAPIParams,
    TCreateTransactionDraftResponse,
    TExportInventoryTransactionListingAPIResponse,
    TGetExportInventoryTransactionListingAPIParams,
    TGetGoldConversionAmountAPIParams,
    TGetGoldConversionListingAPIParams,
    TGetGoldPricesAPIResponse,
    TGetInventoryFilterAPIParams,
    TGetInventoryFilterAPIResponse,
    TGetInventoryListingAPIParams,
    TGetInventoryListingAPIResponse,
    TGetInventoryTransactionListingAPIParams,
    TGetInventoryTransactionListingAPIResponse,
    TGetProductFilterAPIParams,
    TGetProductFilterAPIResponse,
    TGetProductPricePerGramAPIParams,
    TGetSerialNumberFilterAPIParams,
    TGetSerialNumberFilterAPIResponse,
    TGetSerialNumberListingAPIParam,
    TGetSerialNumberListingData,
    TGetSetialNumberListingAPIResponse,
    TGetTotalNetValueOrQuantityAPIParams,
    TGetTransactionListingAPIParams,
    TGetTransactionListingAPIResponse,
    TGetTransactionReceiptAPIParams,
    TGoldConversionListingAPIResponse,
    TGoldTransactionListing,
    TTransferInventoryAPIParams,
    TCreateEarmarkConversionAPIParams,
    TGetEarmarkConversionListingAPIParams,
    TGetEarmarkConversionListingAPIResponse,
    TUpdateEarmarkDetailsAPIParam,
    TGetInventoryUsageAPIResponse,
    TGetInventoryUsageAPIParams,
    TGetInventoryTransfersAPIParams,
    TGetInventoryTransfersAPIResponse,
} from '~types/feat/gold';

import UtilFunctions from '~utils/functions';
import { TGetInventoryTransferListingAPIParams, TGetInventoryTransferListingAPIResponse } from '~types/feat/setting';
import { TGetSilverPricesAPIResponse } from '~types/feat/silver';
import { ISilverGateway } from './silverBase';

const { API: { getHeaders }, Misc: { simulateApi } } = UtilFunctions;

export default class SilverGateway extends ISilverGateway {
    async getSilverPrices(params: ProtectedRoute): GatewayResponse<TGetSilverPricesAPIResponse> {
        const { authToken } = params;
        const response: ApiResponse<TGetSilverPricesAPIResponse> = await this.api.get(
            '/transaction/getSilverPrices',
            {},
            getHeaders(authToken)
        );
        return this.process(response);
    }
}
